'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validationConstants = require('../../validationConstants');

exports.default = function (fieldValue, validationConfig) {
    if (!fieldValue || !validationConfig.validValues) return;

    if (validationConfig.validValues.indexOf(fieldValue) !== -1) return;

    var errorObject = {
        name: _validationConstants.FAILURE_NAMES.select,
        type: _validationConstants.FAILURE_TYPES.ERROR,
        debounced: true,
        message: 'Not a valid select value',
        validValues: validationConfig.validValues.join(',')
    };

    return errorObject;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/type/selectValidator.js
// module id = 2309
// module chunks = 0